import { create } from 'zustand';
import { VoteTier } from '../types/vote';

interface VoteStore {
  isOpen: boolean;
  contestantId: string | null;
  selectedTier: VoteTier | null;
  phoneNumber: string;
  openModal: (contestantId: string) => void;
  closeModal: () => void;
  setSelectedTier: (tier: VoteTier) => void;
  setPhoneNumber: (phone: string) => void;
  reset: () => void;
}

export const useVoteStore = create<VoteStore>((set) => ({
  isOpen: false,
  contestantId: null,
  selectedTier: null,
  phoneNumber: '',
  
  openModal: (contestantId) => set({ isOpen: true, contestantId }),
  closeModal: () => set({ isOpen: false }),
  setSelectedTier: (tier) => set({ selectedTier: tier }),
  setPhoneNumber: (phone) => set({ phoneNumber: phone }),
  reset: () => set({
    isOpen: false,
    contestantId: null,
    selectedTier: null,
    phoneNumber: ''
  })
}));